export const getImageUrl = (market: string): string =>
  market === 'Sembo'
    ? 'https://cdn.sanity.io/images/inntox6v/production/0f0973588039bcb099924319921edac5429f7662-123x32.svg'
    : 'https://cdn.sanity.io/images/inntox6v/production/ebffe849f05e6b7c26b35933e7f8e302f986401c-122x38.svg';
